<template>
  <MonitorWrapper>
    <el-row :gutter="30" class="cb12231-monitor" :class="isChinese ? '' : 'en'">
      <el-col :span="8">
        <div class="bm-item">
          <div class="bm-title">{{ $t('生物气溶胶时间曲线') }}</div>
          <div class="bm-line">
            <Bm4000Line :op="lineOp_1" />
          </div>
        </div>
        <div class="bm-item">
          <div class="bm-title">{{ $t('气溶胶粒子总数时间曲线') }}</div>
          <div class="bm-line">
            <Bm4000Line :op="lineOp_2" />
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="bm-right">
          <div class="right-title">
            <div>{{ $t('粒子数实时数据') }}</div>
            <div class="state-wrap">
              <div
                class="alarm-state"
                :class="[`alarm-state-${bioModVal.alarmState >= 1 ? 1 : 0}`]"
              >
                <span>{{ $t('报警状态') + ':' }}</span>
                <span>
                  {{ bioModVal.alarmContent }}
                </span>
              </div>
              <div class="fault-state" :class="[`fault-state-${bioModVal.fault >= 1 ? 1 : 0}`]">
                <span>{{ $t('故障状态') + ':' }}</span>
                <span>
                  {{ bioModVal.faultContent }}
                </span>
              </div>
              <div class="runstate" :class="[`runstate-${bioModVal.deviceState}`]">
                <span>{{ $t('运行状态') + ':' }}</span>
                <span>
                  {{ $t(deviceStateDict[bioModVal.deviceState]) }}
                </span>
              </div>
            </div>
          </div>
          <div class="right-content">
            <el-row class="content-table">
              <el-col :span="10" class="table-item" :class="state | stateClass(true)">
                <el-row v-for="(v, i) in table_1" :key="i" class="item-row">
                  <el-col :span="12" class="item-col" :title="translateTo(v.label, i18nPath)">
                    {{ v.label | translateTo(i18nPath) }}
                  </el-col>
                  <el-col :span="12" class="item-col" :title="bioModVal[v.key]">
                    {{ bioModVal[v.key] }}
                  </el-col>
                </el-row>
              </el-col>
              <el-col
                :span="13"
                :offset="1"
                class="table-item table_2"
                :class="state | stateClass(true)"
              >
                <el-col :span="8" class="item-row">
                  <div class="item-col">
                    {{ $t('类型') }}
                  </div>
                  <div class="item-col line-2" :title="$t('散射光多通道粒子数模板', { num: 4 })">
                    {{ `${$t('散射光多通道粒子数模板', { num: 4 })}\n(${$t('个秒')})` }}
                  </div>
                  <div class="item-col line-2" :title="$t('荧光多通道粒子数模板', { num: 4 })">
                    {{ `${$t('荧光多通道粒子数模板', { num: 4 })}\n(${$t('个秒')})` }}
                  </div>
                </el-col>
                <el-col :span="4" class="item-row" v-for="(v, i) in table_2" :key="i">
                  <div class="item-col" :title="v.lable">{{ v.label }}</div>
                  <div class="item-col" :title="bioModVal[v.key_1]">{{ bioModVal[v.key_1] }}</div>
                  <div class="item-col" :title="bioModVal[v.key_2]">{{ bioModVal[v.key_2] }}</div>
                </el-col>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row class="bm-bar-box">
              <el-col :span="12" class="bm-bar">
                <Bm4000Bar :op="barOp_1" :min-particle="minParticle" />
              </el-col>
              <el-col :span="12" class="bm-bar">
                <Bm4000Bar :op="barOp_2" :min-particle="minParticle" />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import Bm4000Line from './components/bm4000-line';
import Bm4000Bar from './components/bm4000-bar';

export default {
  components: {
    Bm4000Line,
    Bm4000Bar
  },
  mixins: [singleDeviceMixin],
  sockets: {
    '/socket/basic'(res) {
      if (res.sn !== this.sn) return;
      this.minParticle = res.dynamicInfoMap.minParticle || '0.5';
    }
  },
  data() {
    return {
      i18nPath: 'device',
      length: 0,
      bioModVal: {},
      state: 0,
      lineOp1SeriesData_1: [],
      lineOp1SeriesData_2: [],
      lineOp2SeriesData_1: [],
      lineOp2SeriesData_2: [],
      barOp1SeiresData: [],
      barOp2SeiresData: [],
      alarmStateDict: {
        0: '正常',
        2: '报警'
      },
      faultStateDict: {
        0: '正常',
        1: '故障'
      },
      deviceStateDict: {
        0: '停机',
        1: '运行'
      },
      table_1: [
        { label: '类型', key: 'name' },
        { label: '总气溶胶粒子数\n(个秒)', key: 'parOrAll' },
        { label: '总荧光粒子数\n(个秒)', key: 'bioOrAll' }
      ],
      minParticle: '0.5'
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    ...mapState('socket', ['deviceSNMap']),
    table_2() {
      return [
        { label: `${this.minParticle}-1μm`, key_1: 'parOrSum1', key_2: 'bioOrSum1' },
        { label: '1-2.5μm', key_1: 'parOrSum2', key_2: 'bioOrSum2' },
        { label: '2.5-5μm', key_1: 'parOrSum3', key_2: 'bioOrSum3' },
        { label: '5-10μm', key_1: 'parOrSum4', key_2: 'bioOrSum4' }
      ];
    },
    lineOp_1() {
      return {
        color: ['#5b87ff', '#7b6af1'],
        yAxis: {
          name: this.$t('个升')
        },
        series: [
          {
            name: this.$t('荧光粒子总数'),
            data: this.lineOp1SeriesData_2
          }
        ]
      };
    },
    lineOp_2() {
      return {
        color: ['#f16aec', '#7b6af1'],
        yAxis: {
          name: this.$t('个升')
        },
        series: [
          {
            name: this.$t('气溶胶粒子总数'),
            data: this.lineOp2SeriesData_1
          }
        ]
      };
    },
    barOp_1() {
      return {
        title: { text: this.$t('荧光各通道粒子数') },
        yAxis: {
          name: this.translateTo('粒子数(个秒)')
        },
        xAxis: {
          name: this.translateTo('粒径(μm)')
        },
        series: [{ data: this.barOp1SeiresData }]
      };
    },
    barOp_2() {
      return {
        title: { text: this.$t('气溶胶各通道粒子数') },
        yAxis: {
          name: this.translateTo('粒子数(个秒)')
        },
        xAxis: {
          name: this.translateTo('粒径(μm)')
        },
        series: [{ data: this.barOp2SeiresData }]
      };
    }
  },
  methods: {
    updateTable(newVal) {
      this.bioModVal = { ...newVal.mods.bioMod, name: this.$t('粒子数') };
      this.state = newVal.state;
    },
    updateEchart(newVal) {
      const {
        // bioBground,
        parAll,
        bioAll,
        // noiseBground,
        bioOr1,
        bioOr2,
        bioOr3,
        bioOr4,
        bioOr5,
        bioOr6,
        bioOr7,
        bioOr8,
        bioOr9,
        bioOr10,
        bioOr11,
        bioOr12,
        bioOr13,
        parOr1,
        parOr2,
        parOr3,
        parOr4,
        parOr5,
        parOr6,
        parOr7,
        parOr8,
        parOr9,
        parOr10,
        parOr11,
        parOr12,
        parOr13
      } = newVal.mods.bioMod;
      this.barOp1SeiresData = [
        bioOr1,
        bioOr2,
        bioOr3,
        bioOr4,
        bioOr5,
        bioOr6,
        bioOr7,
        bioOr8,
        bioOr9,
        bioOr10,
        bioOr11,
        bioOr12,
        bioOr13
      ];
      this.barOp2SeiresData = [
        parOr1,
        parOr2,
        parOr3,
        parOr4,
        parOr5,
        parOr6,
        parOr7,
        parOr8,
        parOr9,
        parOr10,
        parOr11,
        parOr12,
        parOr13
      ];
      if (this.length > 29) {
        this.lineOp1SeriesData_2.shift();
        this.lineOp2SeriesData_1.shift();
      }
      this.length++;
      this.lineOp1SeriesData_2.push([newVal.beginTime, bioAll]);
      this.lineOp2SeriesData_1.push([newVal.beginTime, parAll]);
    },
    updateData(newVal) {
      this.updateTable(newVal);
      this.updateEchart(newVal);
    },
    async initPage() {
      if (this.isHisDetail) {
        await this.getHistoryDetailData(this.eventId);
        this.updateTable(this.historyDetailData);
        this.historyDetailDatas.forEach(element => {
          this.updateEchart(element);
        });
        this.hideLoading();
      }
    }
  },
  created() {
    this.initPage();
  }
};
</script>

<style lang="scss">
.cb12231-monitor {
  height: 100%;
  .el-col {
    height: 100%;
    .bm-title {
      height: 60px;
      line-height: 60px;
      font-size: 22px;
      font-weight: bold;
      color: $normal-color;
    }

    .bm-item {
      height: 50%;
      .bm-line {
        height: calc(100% - 60px);
        border-radius: 10px;
        overflow: hidden;
      }
    }

    .bm-right {
      height: 100%;
      .right-title {
        display: flex;
        justify-content: space-between;
        height: 60px;
        line-height: 60px;
        font-size: 22px;
        font-weight: bold;
        color: $normal-color;

        .state-wrap {
          display: flex;
          gap: 15px;
          .alarm-state {
            font-size: 21px;

            &-0 {
              color: $success-color;
            }

            &-2 {
              color: $danger-color;
            }
          }

          .fault-state {
            font-size: 21px;

            &-0 {
              color: $success-color;
            }

            &-1 {
              color: $fix-color;
            }
          }

          .runstate {
            font-size: 21px;

            &-0 {
              color: $unconnect-color;
            }

            &-1 {
              color: $success-color;
            }
          }
        }
      }
      .right-content {
        height: calc(100% - 60px);
        padding: 40px;
        box-sizing: border-box;
        background-color: #121e2c;
        border-radius: 10px;
        .table-item {
          @include state-bgstyle;
          color: #e5f5ef;
          .item-row {
            .item-col {
              height: 50px;
              line-height: 50px;
              text-align: center;
              @include ellipsis-style;
              box-shadow: 0 0 0.5px 0.2px #fff;
            }
            .line-2 {
              line-height: 23px;

              white-space: pre-line;
            }
          }
        }
      }
      .bm-bar-box {
        height: calc(100% - 210px);
        .bm-bar {
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }

  &.en {
    .el-col {
      .bm-right {
        .right-content {
          .table-item {
            .item-row {
              .item-col {
                display: flex;
                align-items: center;
                justify-content: center;

                height: 75px;
                line-height: 23px;
                white-space: pre-line;
              }
            }
          }
        }
        .bm-bar-box {
          height: calc(100% - 255px);
        }
      }
    }
  }
}
</style>
